import { Box, Typography } from "@mui/material"
import ImageCarousel from "../components/ImageCarousel/ImageCarousel"

const Home = () => {

    document.title = '80s Conservation Club - Home'

    return (
        <Box>
            <Typography
                variant="h3"
                align="center"
                sx={{
                    mt: 3,
                    fontWeight: 200,
                    fontSize: {
                        xs: '2rem',
                        sm: '3rem',
                    }
                }}>
                80s Conservation Club
            </Typography>
            <ImageCarousel images={
                [
                    './images/beach.webp',
                    './images/dock.webp',
                    './images/fish.webp',
                    './images/lake_2.webp',
                    './images/lake_3.webp',
                    './images/lake_4.webp',
                    './images/lake_5.webp',
                    './images/lake.webp',
                    './images/deer.webp'
                ]
            }
            />
        </Box>
    )
}

export default Home